document.addEventListener("DOMContentLoaded", () => {
  const questions = document.querySelectorAll(".faq-question");

  questions.forEach((button) => {
    button.addEventListener("click", () => {
      const isExpanded = button.getAttribute("aria-expanded") === "true";
      questions.forEach((btn) => {
        btn.setAttribute("aria-expanded", "false");
        btn.classList.remove("open");

        const answer = btn.nextElementSibling;
        if (answer) {
          answer.classList.remove("open");
          answer.style.height = answer.scrollHeight + "px";
          requestAnimationFrame(() => {
            answer.style.height = "0";
          });
        }
      });

      if (!isExpanded) {
        button.setAttribute("aria-expanded", "true");
        button.classList.add("open");

        const answer = button.nextElementSibling;
        if (answer) {
          answer.classList.add("open");
          answer.style.height = "0";
          requestAnimationFrame(() => {
            answer.style.height = answer.scrollHeight + "px";
          });

          answer.addEventListener("transitionend", function handler() {
            answer.style.height = "auto";
            answer.removeEventListener("transitionend", handler);
          });
        }
      }
    });
  });

  const firstQuestion = questions[0];
  if (firstQuestion) {
    firstQuestion.setAttribute("aria-expanded", "true");
    firstQuestion.classList.add("open");

    const firstAnswer = firstQuestion.nextElementSibling;
    if (firstAnswer) {
      firstAnswer.classList.add("open");
      firstAnswer.style.height = firstAnswer.scrollHeight + "px";
      firstAnswer.addEventListener("transitionend", function handler() {
        firstAnswer.style.height = "auto";
        firstAnswer.removeEventListener("transitionend", handler);
      });
    }
  }
});
